import React from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Nav } from 'react-bootstrap';
import { useEffect } from "react";
import detail_img_data from "./detail_img_data";
import { addItem } from './store'
import { useDispatch } from 'react-redux';
import { All_data } from "./all_data";
import { Img_data } from "./detail_img_data";

interface AllProps {
    all: All_data[];

}

function Detail(props: AllProps): JSX.Element {
    let { id } = useParams();

    let [modal, setModal] = useState<boolean>(false);

    let [tap, setTap] = useState<number>(0);

    let [fade2, setFade2] = useState<string>('')
    useEffect(() => {
        window.scrollTo(0, 0);
        setFade2('end')
        return () => {
            setFade2('')
        }
    }, [])

    let [detail_img] = useState<Img_data>(detail_img_data);

    let selproduct = props.all.find((x: { id: number }) => x.id === Number(id));

    let dispatch = useDispatch();

    return (
        <div className={"detail_wrap start " + fade2}>
            <div className="content">
                <div className="content_img">
                    <img src={'/types'+"/img/all/img" + Number(id) + ".jpg"} width="100%" />
                </div>
                <div className="info">
                    <p className="detail_shipping">
                        <img src="/types/img/shipping.png" />
                    </p>
                    <div className="icon_box">
                        <i className="fa-regular fa-heart" style={{ color: "#000000" }}></i>
                        <span>0</span>
                        <i
                            className="fa-solid fa-share-nodes"
                            style={{ color: "#000" }}
                        ></i>
                    </div>
                    <div className="info_product">
                        <h3>{selproduct?.title}</h3>
                        <div className="product_price_box">
                            <span className="detail_persent">{selproduct?.persent}</span>
                            <span className="detail_saleprice">
                                {selproduct?.saleprice}
                            </span>
                            <span className="detail_price">{selproduct?.price}</span>
                        </div>
                    </div>

                    <div className="info_table">
                        <table className="info_table_top">
                            <tr>
                                <th>제조사/제조국</th>
                                <td>대한민국/자체제작(WV)</td>
                            </tr>
                            <tr>
                                <th>소재</th>
                                <td>면(Cotton) 100%</td>
                            </tr>
                            <tr>
                                <th>배송정보</th>
                                <td>
                                    <p className="d_day_txt">다음 주(월) 도착 예정</p>
                                    <img src="/types/img/shipping.png" />
                                    <br />
                                    <p className="d_day_sub_txt">
                                        뚝딱배송 상품 당일 오후 12시 전 결제 시 오늘 수령
                                        <br />
                                        (서울 지역)
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    카드 할인{" "}
                                    <i
                                        className="fa-solid fa-exclamation"
                                        style={{ color: "#bababa" }}
                                    ></i>
                                </th>
                                <td>5만원 이상 무이자 할부</td>
                            </tr>
                        </table>
                        <div
                            className="detail_member"
                            onClick={() => {
                                setModal(!modal);
                            }}
                        >
                            <p>
                                WV 회원<span>등급별 할인액</span>
                            </p>
                            <i
                                className="fa-solid fa-caret-down"
                                style={{ color: "#000000" }}
                            ></i>
                            {modal == true ? <Modal /> : null}
                        </div>
                        <div className="bot_info">
                            <p>색상/사이즈</p>
                            <select>
                                <option>옵션선택</option>
                                <option>M</option>
                                <option>L</option>
                                <option>XL</option>
                                <option>XXL</option>
                            </select>
                        </div>
                        <div className="total_price">
                            <span>총 상품 금액</span>
                            <strong>{selproduct?.saleprice}</strong>
                        </div>
                        <div className="detail_button">
                            <Button variant="outline-primary" onClick={() => {
                                if (selproduct) {
                                    dispatch(
                                        addItem({
                                            id: selproduct.id,
                                            imgurl: selproduct.imgurl?.replace("img/", ""),
                                            name: selproduct.title,
                                            count: 1,
                                        })
                                    );
                                }
                            }}>장바구니</Button>{" "}
                            <Link to="/cart"><Button variant="dark" onClick={() => {
                                if (selproduct) {
                                    dispatch(
                                        addItem({
                                            id: selproduct.id,
                                            imgurl: selproduct.imgurl?.replace("img/", ""),
                                            name: selproduct.title,
                                            count: 1,
                                        })
                                    );
                                    window.scrollTo(0, 0);
                                }
                            }}>주문하기</Button>{" "}</Link>
                        </div>
                        <div className="detail_pay">
                            <Link to="/cart"><img src="/types/img/detail/kakao.png" onClick = {() => window.scrollTo(0, 0)}/></Link>
                            <Link to="/cart"><img src="/types/img/detail/naver.PNG" onClick = {() => window.scrollTo(0, 0)}/></Link>
                        </div>
                    </div>
                </div>
            </div>

            <Nav variant="tabs" defaultActiveKey="link0">
                <Nav.Item>
                    <Nav.Link onClick={() => { setTap(0) }} eventKey="link0">상품상세</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link onClick={() => { setTap(1) }} eventKey="link1">REVIEW</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link onClick={() => { setTap(2) }} eventKey="link2">배송안내</Nav.Link>
                </Nav.Item>
            </Nav>

            <TabContent tap={tap} detail_img={detail_img}/>
        </div>
    );
}

function Modal() {
    return (
        <div className="detail_member_wrap">
            <div>
                이벤트 세일 상품 및 일부 품목의 회원가는 장바구니와 구매페이지에서
                최종결제금액을 확인 할 수 있습니다.
                <br />
                *일부 이벤트 세일 상품은 해당되지 않을 수 있습니다.
            </div>
            <table>
                <tr>
                    <th>CR 등급</th>
                    <td>39,840원 (20% 할인)</td>
                </tr>
                <tr>
                    <th>WV 등급</th>
                    <td>42,330원 (15% 할인)</td>
                </tr>
                <tr>
                    <th>W 등급</th>
                    <td>44,820원 (10% 할인)</td>
                </tr>
                <tr>
                    <th>V 등급</th>
                    <td>46,314원 (7% 할인)</td>
                </tr>
                <tr>
                    <th>I 등급</th>
                    <td>47,310원 (5% 할인)</td>
                </tr>
                <tr>
                    <th>P 등급</th>
                    <td>48,306원 (3% 할인)</td>
                </tr>
                <tr>
                    <th>C 등급</th>
                    <td>49,302원 (1% 할인)</td>
                </tr>
                <tr>
                    <th>LV.00 등급</th>
                    <td>49,800원 (0% 할인)</td>
                </tr>
            </table>
        </div>
    );
}

interface Tab_Img {
    tap: number;

    detail_img: Img_data;
}

function TabContent({ tap , detail_img }: Tab_Img): JSX.Element {
    let [fade, setFade] = useState('')
    useEffect(() => {
        setTimeout(() => { setFade('end') }, 10)
        return () => {
            setFade('')
        }
    }, [tap])

    let style: React.CSSProperties = {
        paddingTop: '5%',
        marginBottom: 0
    }

    let { id } = useParams();

    return (
        <div className={'start ' + fade}>
            {[<div>
                <p style={{ textAlign: 'center', fontSize: '17px', fontWeight: '400', marginTop: '80px' }}>※ 고객님의 빠른 상품수령과 원활한 배송을 위해 일부상품의 경우 분리배송 되오니 이 점 참고해주세요.</p>
                <div className="delivery_box">
                    <img src="/img/detail/delivery.gif" />
                </div>
                <div className="detail_img_box">
                    <p><img src="/types/img/detail/intro.jpg" /></p>
                    <p><img src={detail_img[Number(id)].imgurl0} /></p>
                    <p><img src={detail_img[Number(id)].imgurl1} /></p>
                    <p><img src={detail_img[Number(id)].imgurl2} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl3} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl4} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl5} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl6} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl7} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl8} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl9} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl10} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl11} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl12} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl13} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl14} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl15} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl16} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl17} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl18} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl19} /></p>
                    <p style={style}><img src={detail_img[Number(id)].imgurl20} /></p>
                </div>
            </div>, <div className="detail_review_img">
                <img src="/types/img/detail/review.png" />
            </div>, <div className="detail_shipping_img">
                <img src="/types/img/detail/shipping1.png" />
                <img src="/types/img/detail/shipping2.png" />
            </div>][tap]}
        </div>
    )
}

export default Detail;
